import { render, staticRenderFns } from "./ArrowDirection.vue?vue&type=template&id=4dc5f4b0&scoped=true&"
import script from "./ArrowDirection.vue?vue&type=script&lang=js&"
export * from "./ArrowDirection.vue?vue&type=script&lang=js&"
import style0 from "./ArrowDirection.vue?vue&type=style&index=0&id=4dc5f4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5f4b0",
  null
  
)

export default component.exports